import { yup } from '@framework/validation/initYup.ts';
import { RuleType } from '../../IRule.ts';
import { type IRuleType } from '../../IRuleType.ts';
import { FileTypeRuleComponent } from './FileTypeRuleComponent.tsx';

const configValidator = yup
  .object({
    value: yup.array().notRequired().label('Formati file ammessi'),
    customMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown();

type IRuleFileType = yup.InferType<typeof configValidator>;

export const FileTypeRule: IRuleType<IRuleFileType> = {
  type: RuleType.FileType,
  name: 'Formati file ammessi',
  configComponent: FileTypeRuleComponent,
  configValidator,
  validator: (schema, rule) => {
    if (!rule?.value) return schema;

    return schema.test({
      name: 'file-type',
      exclusive: false,
      params: { value: rule.value },
      test(value, context) {
        return true;
      },
    });
  },
};
